import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const TripshockCardInfo = styled.div`
    width: ${(props) => (props.isNotFoundType ? '660px' : '360px')};
    margin-top: 30px 0;
    padding-bottom: ${(props) => (props.isNotFoundType ? '92px' : '0px')};
    position: relative;
    box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.5);
    background-color: #fff;
    text-align: ${(props) => props.textAlign};
    z-index: ${(props) => (props.isOpen ? '' : '1')};
    @media (max-width: 768px) {
        width: 90%;
        margin-left: -5%;
    }
`;

export const BrandLink = styled(Link).attrs({
    title: 'TripShock!',
})`
    height: 90px;
    background-color: #2c3944;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Content = styled.div`
    padding: 20px;
`;

export const Text = styled.p`
    color: #4b5259;
    font-size: 18px;
    font-weight: 400;
    margin-top: 20px;
`;

export const Section = styled.section`
    position: relative;
    padding: 0 10px;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-image: url(${(props) => props.backgroundImage});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        filter: blur(5px);
        z-index: -1;
    }
`;

export const Button = styled.button`
    cursor: pointer;
    display: inline-block;
    min-height: 1em;
    outline: none;
    border: none;
    vertical-align: baseline;
    background: #e0e1e2 none;
    font-family: Montserrat, Helvetica, Verdana, Arial, sans-serif;
    margin: 0 0.25em 0 0;
    padding: 0.78571429em 1.5em;
    text-transform: none;
    text-shadow: none;
    font-weight: 700;
    line-height: 1em;
    font-style: normal;
    text-align: center;
    text-decoration: none;
    border-radius: 0.28571429rem;
    user-select: none;
    transition: opacity 0.1s ease, background-color 0.1s ease, color 0.1s ease, box-shadow 0.1s ease,
        background 0.1s ease;
    will-change: '';
    -webkit-tap-highlight-color: transparent;
    font-size: 1rem;
    background-color: #00b357;
    color: #fff;
    background-image: none;
    box-shadow: inset 0 0 0 0 rgba(34, 36, 38, 0.15);

    &:hover {
        text-decoration: none;
        background-color: #21ba45d4;
        color: #fff;
        cursor: pointer;
    }
`;

export const Title = styled.h3`
    font-family: Montserrat;
    color: #4b5259;
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-transform: uppercase;
    margin-bottom: 20px;
`;

export const Form = styled.form`
    display: block;
    position: relative;
    margin-top: 20px;
`;

export const SmallerButton = styled.button`
    display: block;
    width: 195px;
    height: 39px;
    padding: 9px 0;
    margin: 25px auto 20px;
    color: #ffffff;
    font-size: 13px;
    font-weight: 700;
    line-height: 14px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 4px;
    background-color: #62ba37;
    border: none;
    outline: none;
    cursor: pointer;
    transition: all 0.1s linear;
    box-sizing: border-box;
    text-decoration: none;
    &:hover,
    &:active {
        color: #ffffff;
        text-decoration: none;
    }
    &:disabled {
        background-color: rgba(98, 186, 55, 0.8);
        cursor: default;
    }
    @media (min-width: 768px) {
        margin-top: 16px;
    }
`;

export const ErrorMessage = styled.span`
    display: block;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #d26774;
`;

export const NotBluredSection = styled.section`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 100vh;
    background-image: url(${(props) => props.backgroundImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    box-sizing: border-box;
    @media (min-width: 768px) {
        padding: 30px 0;
    }
`;

export const CheckboxWrapper = styled.div`
    margin: 24px 0 16px;
`;

export const Account = styled.div`
    width: 280;
    margin: 30px auto 20px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    color: #2c3944;
    a {
        display: block;
        color: #1690ff;
        text-decoration: none;
    }
    a:hover,
    a:active {
        color: #1690ff;
        text-decoration: none;
    }
`;

export const InnerText = styled.p`
    margin: 0 0 20px;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    color: #4b5259;
`;

export const LoaderWrap = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .spinner {
        width: 25px;
        height: 25px;
    }
    .spinner::before,
    .spinner::after {
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        margin: 0;
        border-radius: 50%;
        border-width: 4px;
        border: 2px solid rgba(255, 255, 255, 0.3);
    }
    .spinner::after {
        border-color: white transparent transparent;
    }
`;
